import React from 'react';

const DisclaimerPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-brand-500 to-brand-700 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">Disclaimer</h1>
          <p className="text-xl text-brand-100">Important information about using our services</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 space-y-8">
          
          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">1. General Information</h2>
            <p className="text-gray-700 leading-relaxed">
              The information provided by 99prop.com, owned and operated by <span className="font-semibold">99Prop Capital</span> ("Company", "we", "us", or "our"), is for general informational and analytical purposes only.
            </p>
            <p className="text-gray-700 leading-relaxed">
              All information on this website is provided in good faith. However, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, completeness, or suitability of any information provided.
            </p>
            <p className="text-gray-700 leading-relaxed font-semibold">
              Your use of the website and reliance on any information is solely at your own risk.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">2. Independent Real Estate Company</h2>
            <p className="text-gray-700 leading-relaxed">
              99prop.com is an independent real estate valuation and acquisition platform operated by <span className="font-semibold">99Prop Capital</span>.
            </p>
            <p className="text-gray-700 leading-relaxed font-semibold">We are:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>An independent property advisory and acquisition company</li>
              <li>Not a public property listing marketplace</li>
              <li>Not affiliated, associated, authorized, endorsed by, or connected with any other real estate portal, listing platform, or brand</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              Any similarity in name, design, or industry presence with other real estate platforms is purely coincidental.
            </p>
            <p className="text-gray-700 leading-relaxed font-semibold">
              We operate independently and do not represent or act on behalf of any third-party portal.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">3. Property Valuations</h2>
            <p className="text-gray-700 leading-relaxed">
              The AI-powered property valuations and analytical outputs provided on the Platform:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Are estimates based on available market data</li>
              <li>Use AI-powered analytical tools and third-party aggregated data sources</li>
              <li>Consider historical trends, location inputs, and algorithmic scoring models</li>
            </ul>
            <p className="text-gray-700 leading-relaxed font-semibold mt-4">These valuations:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Are indicative only</li>
              <li>Do not constitute a certified valuation</li>
              <li>Do not guarantee sale price</li>
              <li>Do not represent a binding offer</li>
              <li>Do not guarantee transaction closure</li>
            </ul>
            <p className="text-gray-700 leading-relaxed font-semibold mt-4">
              Actual market prices may vary based on numerous factors including but not limited to:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Current market conditions</li>
              <li>Property condition and maintenance</li>
              <li>Buyer demand and seller motivation</li>
              <li>Location-specific factors</li>
              <li>Legal, regulatory, and documentation status</li>
              <li>Negotiation between parties</li>
            </ul>
            <p className="text-gray-700 leading-relaxed font-semibold mt-4">
              99Prop Capital shall not be held responsible for any variance between estimated values and actual transaction outcomes.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">4. 48-Hour Sale Claim</h2>
            <p className="text-gray-700 leading-relaxed">
              The "48-hour sale" or fast-closing claim is subject to:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Complete and verified property documentation</li>
              <li>Clear and marketable title</li>
              <li>Property being in acceptable structural and legal condition</li>
              <li>Pricing alignment with prevailing market rates</li>
              <li>Availability of qualified buyers</li>
              <li>Completion of due diligence</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Actual transaction timelines may vary depending on market conditions, negotiation processes, legal clearances, and external factors beyond our control.
            </p>
            <p className="text-gray-700 leading-relaxed font-semibold">
              No guaranteed timeline is implied.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">5. No Professional or Investment Advice</h2>
            <p className="text-gray-700 leading-relaxed">
              The content, projections, ROI illustrations, buyer strategies, growth forecasts, and insights provided on this website:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Do not constitute financial advice</li>
              <li>Do not constitute investment advisory services</li>
              <li>Do not constitute tax advice</li>
              <li>Do not constitute legal advice</li>
              <li>Do not constitute certified valuation services</li>
            </ul>
            <p className="text-gray-700 leading-relaxed font-semibold mt-4">
              Nothing on this Platform should be interpreted as a recommendation to buy, sell, hold, or invest in any property.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Users are strongly advised to consult qualified real estate professionals, chartered accountants, registered valuers, and legal advisors before making any property-related decisions.
            </p>
            <p className="text-gray-700 leading-relaxed font-semibold">
              All decisions are taken at the User's sole discretion and risk.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">6. Market Risk Disclosure</h2>
            <p className="text-gray-700 leading-relaxed">
              Real estate investments involve inherent risks including but not limited to:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Market volatility</li>
              <li>Liquidity constraints</li>
              <li>Regulatory changes</li>
              <li>Policy amendments</li>
              <li>Infrastructure delays</li>
              <li>Project delays</li>
              <li>Construction risks</li>
              <li>Economic downturns</li>
            </ul>
            <p className="text-gray-700 leading-relaxed font-semibold mt-4">
              Past trends and projections do not guarantee future performance.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">7. AI & Data Accuracy</h2>
            <p className="text-gray-700 leading-relaxed">The Platform may use:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>AI-powered analytical tools</li>
              <li>Algorithm-based scoring systems</li>
              <li>Statistical estimation models</li>
              <li>Market trend analytics</li>
              <li>Third-party aggregated data</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">While reasonable efforts are made to maintain accuracy:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>No warranty is provided regarding completeness</li>
              <li>No guarantee is made regarding absolute precision</li>
              <li>Data may be subject to updates, corrections, and revisions</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              Users acknowledge that AI-generated outputs may contain technical or statistical variations.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">8. No Guarantee of Sale or Profit</h2>
            <p className="text-gray-700 leading-relaxed font-semibold">99Prop Capital does not guarantee:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Sale of property within any fixed timeframe</li>
              <li>Availability of buyers</li>
              <li>Capital appreciation</li>
              <li>Rental yield</li>
              <li>Return on investment</li>
              <li>Liquidity</li>
            </ul>
            <p className="text-gray-700 leading-relaxed font-semibold mt-4">
              All transaction outcomes depend on market forces and negotiation.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">9. Third-Party Links</h2>
            <p className="text-gray-700 leading-relaxed">
              Our website may contain links to third-party websites.
            </p>
            <p className="text-gray-700 leading-relaxed">
              99Prop Capital has no control over and assumes no responsibility for:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Content</li>
              <li>Accuracy</li>
              <li>Privacy policies</li>
              <li>Practices of third-party sites</li>
            </ul>
            <p className="text-gray-700 leading-relaxed font-semibold">
              Users access such websites at their own risk.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">10. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed font-semibold">
              Under no circumstances shall 99Prop Capital, its directors, employees, partners, or affiliates be liable for:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Financial losses</li>
              <li>Investment losses</li>
              <li>Opportunity losses</li>
              <li>Transaction delays</li>
              <li>Data inaccuracies</li>
              <li>Negotiation outcomes</li>
              <li>Legal documentation issues</li>
              <li>Market fluctuations</li>
            </ul>
            <p className="text-gray-700 leading-relaxed font-semibold mt-4">
              Use of the Platform is entirely at the User's own risk.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">11. Documentation & Legal Verification</h2>
            <p className="text-gray-700 leading-relaxed">
              99Prop Capital may provide general guidance regarding documentation requirements.
            </p>
            <p className="text-gray-700 leading-relaxed font-semibold">However, we:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Do not verify ownership authenticity</li>
              <li>Do not certify title clearance</li>
              <li>Do not conduct independent legal due diligence</li>
              <li>Do not guarantee regulatory compliance</li>
            </ul>
            <p className="text-gray-700 leading-relaxed font-semibold mt-4">
              Users must independently verify all property documents before entering any transaction.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900">12. Changes to Disclaimer</h2>
            <p className="text-gray-700 leading-relaxed">
              We reserve the right to modify, update, or revise this Disclaimer at any time without prior notice.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Changes will be effective immediately upon posting on the website.
            </p>
            <p className="text-gray-700 leading-relaxed font-semibold">
              Continued use of the Platform constitutes acceptance of the revised Disclaimer.
            </p>
          </section>

          <div className="mt-12 p-6 bg-brand-50 rounded-xl border-l-4 border-brand-500">
            <p className="text-gray-700 font-semibold">
              Last Updated: February 2025
            </p>
            <p className="text-gray-700 mt-2">
              For any questions regarding this Disclaimer, please contact us at{' '}
              <a href="mailto:info@99prop.com" className="text-brand-500 hover:underline font-semibold">
                info@99prop.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerPage;
